/**
 * jun.studio – Product Slider Pijlen
 * Speciaal gemaakt voor jouw Dawn carousel layout
 * Gewoon dit bestand uploaden als Asset en de script-tag toevoegen — klaar.
 */
(function () {
  'use strict';

  // ── CSS injecteren ─────────────────────────────────────────────────────
  function injectCSS() {
    if (document.getElementById('jun-slider-css')) return;
    const css = `
      .jun-arrow {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        z-index: 20;
        width: 42px;
        height: 42px;
        border: none;
        border-radius: 50%;
        background: rgba(255,255,255,0.93);
        box-shadow: 0 2px 10px rgba(0,0,0,0.13);
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        transition: opacity 0.2s, transform 0.2s;
        opacity: 0;
        pointer-events: none;
      }
      .jun-arrow svg {
        width: 16px;
        height: 16px;
        fill: #1a1a1a;
        display: block;
        flex-shrink: 0;
      }
      .jun-arrow--prev { left: 12px; }
      .jun-arrow--next { right: 12px; }
      .jun-arrow.visible {
        opacity: 0.9;
        pointer-events: auto;
      }
      .jun-arrow:hover {
        opacity: 1;
        transform: translateY(-50%) scale(1.07);
      }
      .jun-arrow:active {
        transform: translateY(-50%) scale(0.97);
      }
      /* Wrapper moet position:relative hebben */
      .jun-gallery-wrap {
        position: relative;
        display: block;
      }
    `;
    const style = document.createElement('style');
    style.id = 'jun-slider-css';
    style.textContent = css;
    document.head.appendChild(style);
  }

  // ── Galerij zoeken ─────────────────────────────────────────────────────
  // Dawn carousel gebruikt een <ul> met li's die media bevatten
  // De teller "1 / van 6" staat in een element met aria-label of data
  function findGallery() {
    // Probeer eerst de standaard slider-component
    const sliderComp = document.querySelector("slider-component[id*='GalleryViewer']");
    if (sliderComp) {
      const ul = sliderComp.querySelector('ul');
      if (ul) return { wrapper: sliderComp, list: ul };
    }

    // Jouw carousel: zoek de ul met de productafbeeldingen
    const candidates = document.querySelectorAll('.product ul, .product__media-list, ul.slider');
    for (const ul of candidates) {
      const items = ul.querySelectorAll('li');
      if (items.length > 1) {
        return { wrapper: ul.parentElement, list: ul };
      }
    }

    // Fallback: zoek op basis van de teller "1 / van"
    const counter = document.querySelector('[aria-label*="van"], .slider-counter');
    if (counter) {
      const ul = counter.closest('slider-component, .product__media-wrapper, .product')?.querySelector('ul');
      if (ul) return { wrapper: ul.parentElement, list: ul };
    }

    return null;
  }

  // ── Pijlen aanmaken ────────────────────────────────────────────────────
  function createArrows(wrapper) {
    // Verwijder eventueel bestaande pijlen
    wrapper.querySelectorAll('.jun-arrow').forEach(el => el.remove());

    // Zorg dat wrapper position:relative heeft
    wrapper.classList.add('jun-gallery-wrap');

    const svgPrev = `<svg viewBox="0 0 100 100"><path d="M65,5 L25,50 L65,95 L75,85 L45,50 L75,15 Z"/></svg>`;
    const svgNext = `<svg viewBox="0 0 100 100"><path d="M35,5 L75,50 L35,95 L25,85 L55,50 L25,15 Z"/></svg>`;

    const prev = document.createElement('button');
    prev.className = 'jun-arrow jun-arrow--prev';
    prev.setAttribute('aria-label', 'Vorige afbeelding');
    prev.setAttribute('type', 'button');
    prev.innerHTML = svgPrev;

    const next = document.createElement('button');
    next.className = 'jun-arrow jun-arrow--next';
    next.setAttribute('aria-label', 'Volgende afbeelding');
    next.setAttribute('type', 'button');
    next.innerHTML = svgNext;

    wrapper.appendChild(prev);
    wrapper.appendChild(next);

    return { prev, next };
  }

  // ── Huidige actieve slide vinden ───────────────────────────────────────
  function getActiveIndex(list) {
    const items = Array.from(list.querySelectorAll(':scope > li'));
    // Probeer is-active class
    const activeIdx = items.findIndex(li => li.classList.contains('is-active'));
    if (activeIdx !== -1) return activeIdx;
    // Fallback: meest zichtbare item op basis van scroll
    const scrollLeft = list.scrollLeft;
    const width = list.offsetWidth || 1;
    return Math.round(scrollLeft / width);
  }

  // ── Naar slide scrollen ────────────────────────────────────────────────
  function goToSlide(list, index) {
    const items = Array.from(list.querySelectorAll(':scope > li'));
    if (!items.length) return;

    const clampedIndex = Math.max(0, Math.min(index, items.length - 1));
    const target = items[clampedIndex];

    // is-active bijwerken
    items.forEach(li => li.classList.remove('is-active'));
    target.classList.add('is-active');

    // Horizontaal scrollen (carousel)
    list.scrollTo({
      left: target.offsetLeft,
      behavior: 'smooth'
    });

    // Dawn's eigen slider-component triggeren als dat bestaat
    const sliderComp = list.closest('slider-component');
    if (sliderComp && typeof sliderComp.setActiveSlide === 'function') {
      sliderComp.setActiveSlide(clampedIndex);
    }

    // Teller bijwerken als die bestaat ("1 / van 6")
    const counter = document.querySelector('.slider-counter__current, [class*="slider-counter"]');
    if (counter) {
      counter.textContent = clampedIndex + 1;
    }

    // Bijpassende thumbnail actief maken
    syncThumbnail(target);
  }

  // ── Thumbnail synchroniseren ───────────────────────────────────────────
  function syncThumbnail(activeSlide) {
    const mediaId = activeSlide?.getAttribute('data-media-id');
    if (!mediaId) return;

    document.querySelectorAll('[data-target]').forEach(item => {
      const btn = item.querySelector('button, a');
      if (item.getAttribute('data-target') === mediaId) {
        btn?.setAttribute('aria-current', 'true');
        item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
      } else {
        btn?.removeAttribute('aria-current');
      }
    });
  }

  // ── Pijlen tonen zodra muis over galerij gaat ─────────────────────────
  function setupHover(wrapper, arrows) {
    const show = () => {
      arrows.prev.classList.add('visible');
      arrows.next.classList.add('visible');
    };
    const hide = () => {
      arrows.prev.classList.remove('visible');
      arrows.next.classList.remove('visible');
    };
    wrapper.addEventListener('mouseenter', show);
    wrapper.addEventListener('mouseleave', hide);
  }

  // ── Alles initialiseren ────────────────────────────────────────────────
  function init() {
    injectCSS();

    const gallery = findGallery();
    if (!gallery) {
      // Probeer opnieuw na 1 seconde (sommige thema's laden laat)
      setTimeout(init, 1000);
      return;
    }

    const { wrapper, list } = gallery;
    const items = list.querySelectorAll(':scope > li');
    if (items.length <= 1) return; // Geen pijlen nodig bij 1 afbeelding

    const arrows = createArrows(wrapper);
    setupHover(wrapper, arrows);

    // Pijl klikken
    arrows.prev.addEventListener('click', () => {
      const current = getActiveIndex(list);
      goToSlide(list, current - 1 < 0 ? items.length - 1 : current - 1);
    });

    arrows.next.addEventListener('click', () => {
      const current = getActiveIndex(list);
      goToSlide(list, current + 1 >= items.length ? 0 : current + 1);
    });

    // Scroll detectie (bijhouden welke slide actief is na swipe)
    let scrollTimer;
    list.addEventListener('scroll', () => {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(() => {
        const idx = Math.round(list.scrollLeft / (list.offsetWidth || 1));
        const allItems = Array.from(list.querySelectorAll(':scope > li'));
        allItems.forEach(li => li.classList.remove('is-active'));
        if (allItems[idx]) allItems[idx].classList.add('is-active');
      }, 150);
    }, { passive: true });

    console.log('[jun.studio] Slider pijlen geladen ✓', items.length, 'afbeeldingen');
  }

  // ── Opstarten ──────────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();